import React from 'react';
import PropTypes from 'prop-types';
import { get, includes } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';
import ToggleMenu from './ToggleMenu';
import ContactModal from './ContactModal';
import OSCTag from './OSCTag';

const styles = css`
  width: 100%;
  height: 100px;
  width: 100%;
  position: relative;
  z-index: 10;

  @media(min-width: 992px) {
    height: 115px;
  }
  .Header_logo {
    height: 100%;
    display: block;
    position: absolute;
    padding: 9px 15px;
    z-index: 20;
    img {
      width: auto;
      height: 100%;
    }
    @media (min-width: 992px) {
      height: 115px;
      display: block;
      text-align: center;
      padding-left: 34px;
      position: absolute;
      img {
        width: auto;
        height: 100%;
      }
    }
  }
  .Header_accent {
    height: 19px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    opacity: 0.3;
    background-color: #F1E9D3;
    z-index: 10;
  }
  .Header_menu {
    display: none;
    @media (min-width: 992px) {
      display: block;
      list-style: none;
      padding: 0;
      margin: 19px 0 0 0;
      float: right;
      li {
        display: inline-block;
        color: ${colors.color1};
        text-transform: uppercase;
        font-family: ${typography.SanSerif};
        font-size: 15px;
        a {
          font-weight: 700;
          line-height: 96px;
          padding: 0 15px;
          display: block;
        }
      }
      li:last-child a {
        border: 2px solid ${colors.color2};
        color: #fff;
        background-color: ${colors.color1};
        font-weight: bold;
        letter-spacing: 1.88px;
        line-height: 18px;
        border-radius: 3px;
        padding: 12px 18px;
        margin: 0 20px 0 15px;
        cursor: pointer;
      }
    }
    @media (min-width: 1200px) {
      li {
        padding: 0 20px;
      }
      span {
        margin: 0 35px 0 20px;
      }
    }
  }
  .Header_menuToggle {
    background-color: white;
    background-image: url('/images/icon-hamberger.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 40px;
    height: 100%;
    width: 100px;
    float: right;
    border: 0;
    cursor: pointer;
    display: block;
    position: relative;

    span {
      position: absolute;
      bottom: 18px;
      left: 0;
      right: 0;
      font-size: 12px;
    }
    @media (min-width: 992px) {
      display: none;
    }
  }
  .Header_tab {
    @media (max-width: 1309px){
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  @media (max-width: 1180px){
  padding: 0px !important;
}

  }
  .Header_tabLink {
    @media (max-width: 1084px){
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  }
`;

function getCommunityAgent(community, agents) {
  return agents.filter(a => { return includes(get(community, 'agents'), a._id); })[0];
}

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  render() {
    const { community, agents, builder } = this.props;
    const { menuActive } = this.state;
    const agent = getCommunityAgent(community, agents);
    return (
      <div
        className={styles}
      >
        <div className="Header_accent" />
        <Link className="Header_logo" name="index">
          <img src="/images/woodbridge-logo.svg" alt="Woodbridge Logo" />
        </Link>
        <button id="header-toggle-menu" className="Header_menuToggle" onClick={this.toggleMenu}><span>MENU</span></button>
        <ul className="Header_menu">
          <li className="Header_tab"><Link className="Header_tabLink" name="communities">Our Communities</Link></li>
          <li className="Header_tab"><Link className="Header_tabLink" name="homes">Our Condos</Link></li>
          <li className="Header_tab"><Link className="Header_tabLink" name="photo-gallery">Photo Gallery</Link></li>
          <li className="Header_tab"><Link className="Header_tabLink" name="virtual-tour">Virtual Tours</Link></li>
          <li className="Header_tab"><Link className="Header_tabLink" name="about-us">About Us</Link></li>
          <li className="Header_tab"><Link className="Header_tabLink" name="contact-us">Contact Us</Link></li>
        </ul>
        <ToggleMenu isActive={menuActive} toggleMenu={this.toggleMenu} />
        <ContactModal builder={builder} agent={agent}>
          <OSCTag agent={agent} />
        </ContactModal>
      </div>
    );
  }
}

Header.propTypes = {
  community: PropTypes.object,
  agents: PropTypes.arrayOf(PropTypes.object),
  builder: PropTypes.object.isRequired,
};

Header.defaultProps = {
  home: undefined,
  community: undefined,
  agents: [],
};

export default withData(
  {
    home: true,
    community: true,
    agents: true,
    builder: true,
  },
  {
    required: {
      builder: true,
    },
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js